import { useDispatch, useSelector } from 'react-redux';

import { Box, Typography } from '@material-ui/core';

import Button from '../../../Button/Button.component';

import { setModalStatus } from 'redux/slices/modal.slice';

import { useRequestCheckIn } from 'hooks/client.hook';

const MODAL_NAME = 'EARLY_CHECK_IN';

// Confirmación para cuando el partner hace check-in antes de la hora registrada
// en el escaneo. Se muestra solo en la ventana de 15 a 30 minutos; fuera de ahí
// la fila resuelve sola (ver utils/check-in-window.js).
const EarlyCheckInPanel = () => {
  const { checkInPassId } = useSelector(state => state.client);

  const { mutateAsync, isLoading } = useRequestCheckIn();

  const dispatch = useDispatch();

  const closeModal = () => {
    dispatch(setModalStatus({ isActive: false, name: MODAL_NAME }));
  };

  const onAcceptHandler = () => {
    mutateAsync(checkInPassId).then(closeModal);
  };

  return (
    <Box>
      <Typography>
        La hora registrada en el escaneo aún no ha llegado. ¿Deseas realizar el
        check-in de todos modos? Si no se realiza el escaneo, los resultados no
        se enviarán y esto podría afectar al cliente.
      </Typography>
      <Box
        mt={2}
        display="flex"
        alignItems="center"
        justifyContent="space-around"
      >
        <Button variant="outlined" color="primary" onClick={closeModal}>
          Cancelar
        </Button>
        <Button
          variant="contained"
          color="primary"
          onClick={onAcceptHandler}
          loading={isLoading}
        >
          Realizar check-in
        </Button>
      </Box>
    </Box>
  );
};

export default EarlyCheckInPanel;
